import type { FanEntry } from '@/features/clubs/types'
import { getSportTypeIconUrl } from '@/features/sport-types/lib/sportTypeIcon'

import type { FansLeaderboardRow } from './types'

/** A row carries a club only when the API resolved its name. */
export function entryToRow(entry: FanEntry): FansLeaderboardRow {
  const club =
    entry.club_id && entry.club_name
      ? {
          id: entry.club_id,
          name: entry.club_name,
          logoUrl: entry.club_logo_url,
          country: entry.club_country,
          sportName: entry.club_sport?.name,
          sportIconUrl: entry.club_sport
            ? getSportTypeIconUrl(entry.club_sport)
            : undefined,
          fanCount: entry.club_fan_count
        }
      : undefined
  const hasRequestedClub = !club && Boolean(entry.has_requested_club)
  const requestedSport = entry.requested_club_sport

  return {
    rank: entry.rank,
    userId: entry.user_id,
    name: entry.nickname || entry.full_name || entry.user_id,
    avatarUrl: entry.avatar_url,
    country: entry.country,
    rankName: entry.rank_name || undefined,
    totalViews: entry.total_views ?? 0,
    bestViews: entry.best_views ?? 0,
    arenaPoints: entry.arena_points ?? 0,
    tasks: entry.tasks_success_count ?? 0,
    club,
    hasRequestedClub,
    requestedAthlete:
      hasRequestedClub && entry.requested_participant_type === 'ATHLETE',
    requestedClubSport:
      hasRequestedClub && requestedSport?.name
        ? {
            name: requestedSport.name,
            iconUrl: getSportTypeIconUrl(requestedSport)
          }
        : undefined
  }
}
